import { FileAttachmentIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Show
} from "shared/components";
import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";

export interface PendingAttachment {
  id: string;
  file: File;
  status: "uploading" | "uploaded" | "error";
  uploadUrl?: string;
}

export const NoteAttachmentCard = ({
  id,
  filename,
  caption,
  isUploading = false,
  onRemove
}: {
  id: string;
  filename: string;
  caption?: string;
  isUploading?: boolean;
  onRemove: (id: string) => void;
}) => {
  return (
    <Card className="w-[300px] flex items-center gap-3 px-4 py-3">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-20">
        <HugeiconsIcon
          icon={FileAttachmentIcon}
          size={20}
          strokeWidth={1.5}
          className="text-primary-500"
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-content-1000">
          {filename}
        </p>
        <Show if={Boolean(caption)}>
          <p className="text-xs text-content-200">{caption}</p>
        </Show>
      </div>
      {isUploading ? (
        <Loader size={16} />
      ) : (
        <IconButton
          variant={IconButtonVariant.BASE}
          size={IconButtonSize.XS}
          HugeIcon={Delete01Icon}
          onClick={() => onRemove(id)}
        />
      )}
    </Card>
  );
};
